import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageSaintGenis: React.FC = () => (
  <LocalSeoPage
    city="Saint-Genis-Pouilly"
    cityShort="Saint-Genis"
    slug="depannage-informatique-saint-genis-pouilly"
    metaTitle="Dépannage Informatique Saint-Genis-Pouilly | SOS IT"
    metaDescription="Technicien informatique à Saint-Genis-Pouilly. Réparation PC, virus, WiFi, Windows bloqué. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur vous pose problème à Saint-Genis-Pouilly ? Notre technicien intervient rapidement à domicile ou à distance. PC lent, virus, panne WiFi ou Windows bloqué — on règle ça simplement, avec un diagnostic 100 % gratuit et sans engagement."
    postalCode="01630"
    nearbyTowns={[
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Prévessin-Moëns', link: '/depannage-informatique-prevessin-moens' },
      { name: 'Divonne-les-Bains', link: '/depannage-informatique-divonne-les-bains' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Thoiry' },
      { name: 'Cessy' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Ferney-Voltaire', href: '/depannage-informatique-ferney-voltaire' },
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Prévessin-Moëns', href: '/depannage-informatique-prevessin-moens' },
      { label: 'Dépannage informatique à Divonne-les-Bains', href: '/depannage-informatique-divonne-les-bains' },
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageSaintGenis;
